import { render, staticRenderFns } from "./EvidenceList.vue?vue&type=template&id=33dea28e&scoped=true"
import script from "./EvidenceList.vue?vue&type=script&lang=js"
export * from "./EvidenceList.vue?vue&type=script&lang=js"
import style0 from "./EvidenceList.vue?vue&type=style&index=0&id=33dea28e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dea28e",
  null
  
)

export default component.exports